<template>
  <van-popup v-model="showSelector" position="bottom">
    <van-datetime-picker
      v-model="curDate"
      :type="mode"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="selectConfirm"
      @cancel="selectCancel" />
  </van-popup>
</template>

<script>
import { commonUtils } from '@/utils/common'
export default {
  name: 'DateTimeSelector',
  props: {
    mode: {
      type: String,
      default: 'date'
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showSelector: false,
      curDate: '',
      minDate: new Date(2018, 0, 1),
      maxDate: new Date(2019, 11, 31)
    }
  },
  watch: {
    value (val) {
      this.curDate = this.mode === 'time' ? val : new Date(val)
    }
  },
  created () {
    if (this.mode === 'time') {
      this.curDate = this.value
    } else {
      this.curDate = this.value ? new Date(this.value) : new Date()
    }
  },
  methods: {
    show () {
      this.showSelector = true
    },
    selectConfirm () {
      this.showSelector = false
      // console.log(this.curDate)
      if (this.mode === 'date') {
        this.$emit('input', commonUtils.parseTime(this.curDate, '{y}-{m}-{d}'))
      }
      if (this.mode === 'datetime') {
        this.$emit('input', commonUtils.parseTime(this.curDate))
      }
      if (this.mode === 'time') {
        this.$emit('input', this.curDate)
      }
    },
    selectCancel () {
      this.showSelector = false
    }
  }
}
</script>

<style>

</style>
